module.exports = __webpack_public_path__ + "img/mockup2.318b5c82.png";